import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const SumberProduksi = () => {
  const [kodeSawit, setKodeSawit] = useState("");
  const [loading, setLoading] = useState(false);

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return num || "-";
    return Number(num).toLocaleString("id-ID");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (kodeSawit.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Kode sawit tidak boleh kosong!",
        confirmButtonColor: "#0d9488",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/rincian_sumber",
        {
          kode_sawit: kodeSawit,
        },
        { withCredentials: true }
      );

      if (response.status === 200) {
        const data = response.data;
        const isSertified = String(data.sertifikasi_lahan || "").toLowerCase().includes("terverifikasi") ||
                            String(data.sertifikasi_lahan || "").toLowerCase().includes("ada") ||
                            String(data.sertifikasi_lahan || "").toLowerCase().includes("certified");

        Swal.fire({
          title: `<div class="text-center pt-2 pb-2 border-bottom"><h4 class="fw-bold m-0" style="color: #0d9488; font-family: 'Poppins', sans-serif;"><i class="fa fa-seedling me-2"></i>Rincian Sumber Produksi</h4></div>`,
          html: `
            <div class="text-start mt-3" style="font-size: 0.9rem; font-family: 'Poppins', sans-serif; color: #374151; max-height: 70vh; overflow-y: auto; padding-right: 4px;">
              
              <!-- Banner Utama: Kode Sawit & Berat -->
              <div class="p-3 mb-3 rounded-4 d-flex justify-content-between align-items-center" style="background: linear-gradient(135deg, #e6fffa, #ccfbf1); border: 1px solid #99f6e4;">
                <div>
                  <span style="font-size: 11px; color: #0f766e; text-transform: uppercase; font-weight: 700; display: block; margin-bottom: 2px;">Kode Sawit</span>
                  <span class="font-monospace fw-bold fs-6" style="color: #0d9488;">${kodeSawit}</span>
                </div>
                <div class="text-end">
                  <span style="font-size: 11px; color: #0f766e; text-transform: uppercase; font-weight: 700; display: block; margin-bottom: 2px;">Berat Sawit</span>
                  <h4 class="font-monospace fw-bold m-0 text-dark">${formatNumber(data.berat_sawit)} kg</h4>
                </div>
              </div>

              <!-- Grid Detail Entitas & Lahan -->
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; background: #f8fafc; padding: 16px; border-radius: 14px; margin-bottom: 16px; border: 1px solid #e2e8f0;">
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Nama Petani</span>
                  <span style="font-weight: 600; color: #1e293b;">${data.nama_petani || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Jenis Sawit</span>
                  <span style="font-weight: 600; color: #1e293b;">${data.jenis_sawit || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Usia Tanaman</span>
                  <span style="font-weight: 600; color: #1e293b;">${data.usia ? `${data.usia} Tahun` : "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Sertifikasi Lahan</span>
                  <span class="badge ${isSertified ? "bg-success-subtle text-success border-success-subtle" : "bg-secondary-subtle text-secondary border-secondary-subtle"} border px-2 py-1 rounded-pill" style="font-size: 11px;">
                    ${data.sertifikasi_lahan || "Belum Tersertifikasi"}
                  </span>
                </div>
                <div style="grid-column: span 2;">
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Lokasi Lahan</span>
                  <span style="color: #475569;">${data.lahan || "-"}</span>
                </div>
              </div>

              <!-- Grid Riwayat Tanggal & Waktu -->
              <h6 class="fw-bold mb-2" style="font-size: 0.95rem; color: #0f766e;">Riwayat Waktu & Alur Distribusi</h6>
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; background: #ffffff; padding: 14px; border-radius: 12px; border: 1px solid #e2e8f0;">
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block;">Tanggal Tanam</span>
                  <span style="font-size: 0.85rem; color: #334155; font-weight: 500;">${data.tanggal_tanam || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block;">Tanggal Panen</span>
                  <span style="font-size: 0.85rem; color: #334155; font-weight: 500;">${data.tanggal_panen || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block;">Tanggal Pengiriman</span>
                  <span style="font-size: 0.85rem; color: #334155; font-weight: 500;">${data.tanggal_pengiriman || "-"}</span>
                </div>
                <div>
                  <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block;">Diterima Pabrik</span>
                  <span style="font-size: 0.85rem; color: #334155; font-weight: 500;">${data.tanggal_diterima_pabrik || "-"}</span>
                </div>
              </div>

            </div>
          `,
          confirmButtonText: "Tutup",
          confirmButtonColor: "#0d9488",
          background: "#ffffff",
          width: "720px",
          showCloseButton: true,
          focusConfirm: false,
          customClass: {
            popup: "rounded-4 shadow-lg border-0 p-4",
            confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
          },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Tidak Ditemukan",
          text: "Pastikan kode sawit yang Anda masukkan benar.",
          confirmButtonColor: "#0d9488",
          customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Terjadi Kesalahan",
        text: "Kode sawit tidak ditemukan pada sistem.",
        confirmButtonColor: "#0d9488",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="sumberProduksiSection"
      className="py-5"
      style={{
        backgroundColor: "#28dbcf",
        minHeight: "380px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center w-100 m-0">
          <Col xs={12} className="mb-3 text-center">
            <h1
              className="fw-bold text-white mb-1"
              style={{
                fontFamily: "Poppins, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              Lacak Sumber Produksi
            </h1>
            <p className="text-white opacity-75 small mb-0">
              Verifikasi asal usul kebun, riwayat tanam, panen, hingga distribusi pabrik secara terintegrasi.
            </p>
          </Col>

          <Col xs={11} sm={8} md={6} lg={5}>
            <Form onSubmit={handleSubmit} className="p-4 rounded-4 shadow-sm bg-white border">
              <Form.Group className="mb-3 text-start" controlId="kodeSawit">
                <Form.Label
                  className="fw-bold text-secondary mb-2"
                  style={{ fontSize: "0.95rem", fontFamily: "Poppins, sans-serif" }}
                >
                  Kode Sumber Sawit
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contoh: SMBR180225670744"
                  value={kodeSawit}
                  onChange={(e) => setKodeSawit(e.target.value)}
                  required
                  className="shadow-none rounded-3 py-2 px-3"
                  style={{ borderColor: "#cbd5e1", fontSize: "0.95rem" }}
                />
              </Form.Group>

              <div className="text-center">
                <Button
                  type="submit"
                  disabled={loading}
                  className="w-100 shadow-sm fw-bold py-2 rounded-pill text-uppercase border-0"
                  style={{
                    backgroundColor: "#0d9488",
                    color: "#ffffff",
                    letterSpacing: "0.5px",
                    transition: "all 0.2s ease",
                  }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Memeriksa...
                    </>
                  ) : (
                    "Cek Sumber Produksi"
                  )}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SumberProduksi;